import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { ResponsivePicture } from '../../../Shared/components/Image';
import { BranchLocalizationLayout } from '../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationLayout';
import { hyphenate } from "../../../Shared/features/hyphenate";
import { isHomeJumbo, renderContents } from "../../custom_components/components/jumbo/jumboUtils";
import { LinkButton } from '../../custom_components/components/library/button';
import { trackJumboButton } from '../../custom_components/components/library/tracking';
const JumboHeading = (props)=>{
    const { supertitle, title, subtitle } = props;
    return /*#__PURE__*/ _jsxs("header", {
        children: [
            supertitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__supertitle title--md",
                children: supertitle
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "jumbotron__title title--xl",
                children: hyphenate(title)
            }),
            subtitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__subtitle title--md",
                children: subtitle
            })
        ]
    });
};
export const homeJumbo = (props)=>/*#__PURE__*/ _jsxs("header", {
        className: "jumbotron jumbotron--large jumbotron--home",
        children: [
            isHomeJumbo(props) && /*#__PURE__*/ _jsx(BranchLocalizationLayout, {
                ...props.localizationProps
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "jumbotron__outer",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "jumbotron__inner container--full gutter--m align--center",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "jumbotron__content container--s",
                            children: [
                                /*#__PURE__*/ _jsx(JumboHeading, {
                                    ...props
                                }),
                                props.contents.toString().length > 0 || props.buttonUrl && props.buttonTitle ? /*#__PURE__*/ _jsxs("div", {
                                    className: "jumbotron__intro",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "text--styled",
                                            children: props.contents.toString().length > 0 && renderContents(props.contents, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {}))
                                        }),
                                        props.buttonUrl && props.buttonTitle && /*#__PURE__*/ _jsx(LinkButton, {
                                            variant: "black",
                                            arrow: false,
                                            route: props.buttonUrl,
                                            handle: ()=>trackJumboButton(props.buttonTitle),
                                            className: "button button--primary button--arrow jumbotron__clickable",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "button__label",
                                                children: props.buttonTitle
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ _jsx(_Fragment, {})
                            ]
                        }),
                        props.imageUrl && /*#__PURE__*/ _jsx("div", {
                            className: "jumbotron__visual fit-object",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                                defaultImageUrl: props.imageUrlFallback,
                                cropsPerMedia: [
                                    {
                                        crops: [
                                            {
                                                url: props.imageUrlSmall,
                                                width: 470
                                            },
                                            {
                                                url: props.imageUrl,
                                                width: 940
                                            },
                                            {
                                                url: props.imageUrlLarge,
                                                width: 1880
                                            }
                                        ]
                                    }
                                ],
                                lazyload: false,
                                width: 940,
                                height: 940,
                                alt: props.imageAlt
                            })
                        })
                    ]
                })
            })
        ]
    });
export const largeJumbo = (props)=>/*#__PURE__*/ _jsx("header", {
        className: `jumbotron jumbotron--large jumbotron--default ${props.kind && `jumbotron--${props.kind}`}`,
        children: /*#__PURE__*/ _jsx("div", {
            className: "jumbotron__outer",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "jumbotron__inner container--full gutter--m align--center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "jumbotron__content container--s",
                        children: [
                            /*#__PURE__*/ _jsx(JumboHeading, {
                                ...props
                            }),
                            props.contents.toString().length > 0 || props.buttonUrl && props.buttonTitle ? /*#__PURE__*/ _jsxs("div", {
                                className: "jumbotron__intro",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "text--styled",
                                        children: props.contents.toString().length > 0 && renderContents(props.contents, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {}))
                                    }),
                                    props.openingHoursComponent,
                                    props.buttonUrl && props.buttonTitle && /*#__PURE__*/ _jsx(LinkButton, {
                                        variant: "white",
                                        arrow: true,
                                        route: props.buttonUrl,
                                        handle: ()=>trackJumboButton(props.buttonTitle),
                                        className: "jumbotron__clickable",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "button__label",
                                            children: props.buttonTitle
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    }),
                    props.imageUrl && /*#__PURE__*/ _jsx("div", {
                        className: "jumbotron__visual fit-object",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                            defaultImageUrl: props.imageUrlFallback,
                            cropsPerMedia: [
                                {
                                    crops: [
                                        {
                                            url: props.imageUrlSmall,
                                            width: 470
                                        },
                                        {
                                            url: props.imageUrl,
                                            width: 940
                                        },
                                        {
                                            url: props.imageUrlLarge,
                                            width: 1880
                                        }
                                    ]
                                }
                            ],
                            lazyload: false,
                            width: 940,
                            height: 940,
                            alt: props.imageAlt
                        })
                    })
                ]
            })
        })
    });
